module.exports = __webpack_public_path__ + "static/assets/a59cc80614c5bbb2761bc79b07fd46e2.gif";